module.exports = __webpack_public_path__ + "img/AD2.eb968c29.png";